function initHorizontalDragScroll(container) {
    var isDragging = false;
    var startX = 0;
    var scrollLeft = 0;
    var moved = false;

    container.addEventListener('mousedown', function (event) {
        if (event.button !== 0) {
            return;
        }

        isDragging = true;
        moved = false;
        startX = event.pageX;
        scrollLeft = container.scrollLeft;
        container.classList.add('is-dragging');
    });

    container.addEventListener('mousemove', function (event) {
        if (!isDragging) {
            return;
        }

        var walk = event.pageX - startX;
        if (Math.abs(walk) > 3) {
            moved = true;
        }

        container.scrollLeft = scrollLeft - walk;
    });

    function stopDragging() {
        isDragging = false;
        container.classList.remove('is-dragging');
    }

    container.addEventListener('mouseup', stopDragging);
    container.addEventListener('mouseleave', stopDragging);

    container.addEventListener('click', function (event) {
        if (moved) {
            event.preventDefault();
            event.stopPropagation();
            moved = false;
        }
    }, true);
}

function c24McpBotIsNativeApp() {
    if (window.c24TheBotSettings && window.c24TheBotSettings.isApp) {
        return true;
    }
    if (typeof window.aiBotBridge !== 'undefined') {
        return true;
    }
    return typeof window.webkit !== 'undefined'
        && typeof window.webkit.messageHandlers !== 'undefined'
        && typeof window.webkit.messageHandlers.aiBotBridge !== 'undefined';
}

// Native app: the web embed's on-demand init is never wired up, so we drive the
// bridge directly (handshake -> init -> open -> send), mirroring the mobile app.
function c24McpBotOpenNative(question) {
    var bridge = window.c24TheBot.bridge;
    var settings = window.c24TheBotSettings || {};
    var openState = window.c24TheBotOpenState || window.c24TheBot.PresentationState.FullSheet;

    var ready = bridge.initialized
        ? Promise.resolve()
        : bridge.initializeBridge().then(function () {
            return bridge.initializeTheBot({
                agentSlug: settings.agentSlug || '',
                getInitialWorkflowsCallback: function () {
                    var workflows = settings.initialWorkflows;
                    return Promise.resolve(Array.isArray(workflows) ? workflows : []);
                }
            });
        });

    return ready.then(function () {
        return bridge.setPresentationState(openState);
    }).then(function () {
        if (question) {
            return bridge.sendMessage(question);
        }
    });
}

function c24McpBotOpenBot(question) {
    if (!window.c24TheBot) {
        return;
    }

    if (question === 'Ich möchte einen Vertrag widerrufen') {
        window.c24TheBotSettings = window.c24TheBotSettings || {};
        window.c24TheBotSettings.initialWorkflows = [{name: 'workflow-reserve-revocation'}];
    }

    var flow = c24McpBotIsNativeApp()
        ? c24McpBotOpenNative(question)
        : window.c24TheBot.ensureTheBotInitialized().then(function () {
            return window.c24TheBot.open();
        }).then(function () {
            if (question) {
                return window.c24TheBot.sendMessage(question);
            }
        });

    flow.catch(function (error) {
        console.error('[mcp-bot] Could not open bot:', error);
    });
}

function c24McpBotBarWithChipsInit() {
    document.querySelectorAll('.question-contents').forEach(initHorizontalDragScroll);

    var thebotSearch = document.querySelector('.thebot-search');
    if (thebotSearch) {
        thebotSearch.addEventListener('click', function (event) {
            if (!window.c24TheBot) {
                return;
            }

            event.preventDefault();
            c24McpBotOpenBot();
        });
    }

    var chatQuestions = document.querySelectorAll('.chat-question');

    chatQuestions.forEach(function (button) {
        button.addEventListener('click', function (event) {
            if (!window.c24TheBot) {
                return;
            }

            event.preventDefault();
            c24McpBotOpenBot(button.textContent.replace(/\s+/g, ' ').trim());
        });
    });
}

document.addEventListener('DOMContentLoaded', c24McpBotBarWithChipsInit);
